import React, { useRef, useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";

import SvgComponent from "../components/Svg2Component";

//librerias de microsoft
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../microsoft/authConfig";

function DashboardAlt() {
 
  const { instance, accounts } = useMsal();
  const [datosExcel, setDatosExcel] = useState([]);


  useEffect(() => {
    const loginAndFetchExcel = async () => {
      try {
        
        let account = instance.getActiveAccount();

        // Inicia sesión si no hay cuenta activa
        if (accounts.length === 0) {

          const loginResponse = await instance.loginPopup(loginRequest);
          account = loginResponse.account;
          console.log("Logueado como :", loginResponse.account.username);
          
          // Lo establece como cuenta activa
          instance.setActiveAccount(account);
        }

        //Obtiene el token
        const tokenResponse = await instance.acquireTokenSilent({
          ...loginRequest,
          account: account,
        });

        const accessToken = tokenResponse.accessToken;

        // Sitio de excel
        const response = await fetch(
          "https://graph.microsoft.com/v1.0/me/drive/root:/Demo Ore Control Media Luna.xlsx:/workbook/worksheets('qry_combinado')/usedRange",
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );

        const data = await response.json();
        const allRows = data.values;

        // Elimina los encabezados del exel:
        const rowsWithoutHeader = allRows.slice(1);
        setDatosExcel(rowsWithoutHeader);
        
      } catch (err) {
        console.error(err);
      }
    };

    loginAndFetchExcel();
  }, [instance, accounts]);
  


  return (
    <section className="bg-fondo_blanco shadow-xl rounded-lg">
      <div className="h-[calc(82vh)] w-full flex flex-col items-center justify-center px-6 py-8 mx-auto lg:py-0">  
        <p 
          className="text-ceniza font-worksans text-[45px] font-bold uppercase  pointer-events-none select-none"
          style={{
            position: "absolute",
            top: "16%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            whiteSpace: "nowrap",
            letterSpacing: "7px",
            zIndex: 1000,
            opacity: 0.5
          }}
        >
          Grade Control System Media Luna
        </p>
        <SvgComponent datosExcel={datosExcel}/>
      </div>
    </section>
  );
}

export default DashboardAlt;
